module.exports = __webpack_public_path__ + "img/artifact_image.da1bdf5c.png";